import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { PrivacyPolicyPopup } from './PrivacyPolicyPopup';
export function Footer() {
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  return <footer className="w-full bg-teal-800 text-white py-10 px-4" data-id="element-50">
      <div className="max-w-5xl mx-auto" data-id="element-51">
        <div className="flex flex-col items-center justify-center mb-8" data-id="element-52">
          <div className="flex items-center mb-4" data-id="element-53">
            <Heart size={24} className="text-teal-200 mr-2" data-id="element-54" />
            <h3 className="text-xl font-semibold" data-id="element-55">Eat To Heal</h3>
          </div>
          <p className="text-teal-100 text-center max-w-2xl" data-id="element-56">
            This program is designed for educational purposes and does not
            replace professional medical advice. Always consult with your doctor
            before making significant changes to your diet.
          </p>
        </div>
        <div className="border-t border-teal-700 pt-6 text-center" data-id="element-57">
          <p className="text-sm text-teal-200" data-id="element-58">
            © {new Date().getFullYear()} Eat To Heal. All rights reserved.
          </p>
          <div className="flex justify-center mt-4" data-id="element-59">
            <button onClick={() => setIsPrivacyPolicyOpen(true)} className="text-teal-200 hover:text-white transition" data-id="element-60">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
      <PrivacyPolicyPopup isOpen={isPrivacyPolicyOpen} onClose={() => setIsPrivacyPolicyOpen(false)} data-id="element-61" />
    </footer>;
}